/* eslint-disable no-unused-vars */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Forecast from 'assets/icons/forecast.svg';
import CardHeaderContainer from 'component/CardHeaderContainer/CardHeaderContainer';
import {
  ForecastCardInspected,
  ForecastCardInterested,
  ForecastCardOffer,
} from 'component/ForecastCard/ForecastCard';
import PredicationCard from 'component/PredicationCard/PredicationCard';
import React from 'react';
import { displayFlex } from 'theme/common.style';
import { forecastContainer } from './ForestContainer.style';
import { ExpandMoreOutlined } from '@mui/icons-material';
import { useTheme } from '@emotion/react';

function ForecastContainer(props) {
  // const [expanded, setExpanded] = React.useState("panel1");

  const { forecastData, response, profileDetails } = props;
  const propertystatus = profileDetails?.PropertyDetails?.property?.status;
  const [expanded, setExpanded] = React.useState(
    propertystatus == 'Unpublish' ? false : 'panel1'
  );
  const data = forecastData;

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  React.useEffect(() => {
    setExpanded(propertystatus == 'Unpublish' ? false : 'panel1');
  }, [response]);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Accordion
      // classes={{
      //   root: classes.summary,
      // }}
      expanded={expanded === 'panel1'}
      onChange={handleChange('panel1')}
      sx={{ ...forecastContainer, borderRadius: matchessm ? '10px' : '5px' }}
    >
      <AccordionSummary
        sx={{ color: '#0065FC' }}
        expandIcon={
          <Typography
            sx={{
              border: '1px solid #F0F0F0',
              padding: '8px 5px',
              height: '100%',
              display: 'flex',
              borderRadius: '5px',
              alignItems: 'center',
              width: '41px',
              justifyContent: 'center',
              alignContent: 'center',
              cursor: 'pointer',
            }}
          >
            <ExpandMoreOutlined sx={{ color: '#0065FC' }} />
          </Typography>
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <CardHeaderContainer title="Forecast" icon={Forecast} />
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          sx={displayFlex}
          container
          spacing={2}
          style={{ marginTop: '-30px' }}
        >
          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <ForecastCardInspected
              title="Buyers Inspected Forecast"
              data={data}
              response={response}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <ForecastCardInterested
              title="Interested Parties Forecast"
              data={data}
              response={response}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <ForecastCardOffer
              title="Offer Cast"
              data={data}
              response={response}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
            <PredicationCard title="Price Prediction" data={data} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

ForecastContainer.propTypes = {};

export default ForecastContainer;
